import { useEffect, useState } from "react"
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance"
import Form from "../../../../Partials/Layouts/Forms/Form"
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput"
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton"
import { BRANDS_API } from "../../../../../Utilities/APIs/APIs"
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput"
import slugify from "react-slugify"

function UpdateBrand({ targetID, triggerFetch, setShowUpdateForm }) {

    const axiosInstance = useAxiosInstance()

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [precedence, setPrecedence] = useState('')
    const [brandCategory, setBrandCategory] = useState('')
    const [isActive, setIsActive] = useState('')

    useEffect(() => {
        async function fetchAndSetSingleCatagory() {
            const { data } = await axiosInstance.get(BRANDS_API + 'getSingleBrand/' + targetID)
            setName(data.name)
            setDescription(data.description)
            setBrandCategory(data.brandCategory)
            setPrecedence(data.precedence)
            setIsActive(data.isActive)
        }
        fetchAndSetSingleCatagory()

    }, [targetID, axiosInstance])

    async function handleSubmit(e) {

        e.preventDefault()
        const itemData = new FormData()

        itemData.append('name', name)
        itemData.append('slug', slugify(name))
        itemData.append('description', description)
        itemData.append('precedence', precedence)
        itemData.append('brandCategory', brandCategory)
        itemData.append('isActive', isActive)

        const response = await axiosInstance.patch(BRANDS_API + targetID, itemData)
        if (response) {
            triggerFetch()
            setShowUpdateForm(false)
        }
    }

    return (
        <div className='crate_form'>
            <Form onSubmit={handleSubmit}>
                <div>
                    <ShortTextInput
                        label={`Brand Name`}
                        value={name}
                        placeholder={`Brand Name`}
                        setState={setName}
                    />

                    <ShortTextInput
                        label={`Description`}
                        value={description}
                        placeholder={`Description`}
                        setState={setDescription}
                    />
                    <ShortTextInput
                        label={`Brand Category`}
                        value={brandCategory}
                        placeholder={`Category Code`}
                        setState={setBrandCategory}
                    />
                    <ShortTextInput
                        label={`Precedence`}
                        value={precedence}
                        placeholder={`Precedence`}
                        setState={setPrecedence}
                    />
                     <ShortTextInput
                        label={`Slug`}
                        value={slugify(name)}
                        placeholder={`Enter Slug`}
                        disabled
                    />

                    <SwitchInput
                        label={`Status`}
                        toggleSwitch={() => setIsActive(prevState => !prevState)}
                        checked={isActive}
                    />
                </div>
                <FormSubmitButton text="Submit" />
            </Form>
        </div>
    )
}

export default UpdateBrand